import React from 'react'

import { useHelpActions } from '../../utils/contexts/HelpProvider'
import FixedRoundButton from '../../components/actions/FixedRoundButton'

const HelpButton = () => {
  const { openPrimaryHelpOption } = useHelpActions()

  return <FixedRoundButton size={3} onLeft icon="RiQuestionAnswerLine" onClick={openPrimaryHelpOption} />
}

export default HelpButton
